import React, { useContext, useRef } from 'react';
import '../../css/DuplicateDialog.scss';
import ReactModal from 'react-modal-resizable-draggable';
import { MobXProviderContext, observer } from 'mobx-react';
import itemBankService from '../services/ItemBankService';
import { register } from '../../i18n';
import useAccessibilityClick from '../../hooks/useAccessibilityClick';

const t = register('DuplicateDialog');

const DuplicateDialog = observer(() => {
  const {
    itemBankManager
  } = useContext(MobXProviderContext);

  const closeRef = useRef();
  useAccessibilityClick(closeRef, () => {
    itemBankService.setDuplicateDialogOpen(false);
  });

  return (
    <>
      {(itemBankManager.duplicateDialogOpen) && (
        <div className='duplicate-dialog'>
          <ReactModal
            disableResize={true}
            initHeight={200}
            initWidth={350}
            isOpen={itemBankManager.duplicateDialogOpen}
            onRequestClose={() => { itemBankService.setDuplicateDialogOpen(false); }} top={250} role="dialog" >
            <div className='duplicate-dialog-body'  >

              <div className='solution-header'>
                <h2 className='title-label basic'>{t('headerLabel')}</h2>
                <div ref={closeRef} aria-label='close dialog' className='x-close-button mask-image' role='button' tabIndex='0' />
              </div>
              <div className='duplicate-dialog-body-message'> {t('body')}</div>

            </div>

          </ReactModal>
        </div>
      )}
    </>
  );
});

export default DuplicateDialog;
